module.exports = __webpack_public_path__ + "niue.svg?74efe863a0b748748c83c9819fe8c171";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/niue.svg
// module id = 250
// module chunks = 10